module.exports = __webpack_public_path__ + "img/FIRMA_DOCUMENTOSMOV.19d8ed07.svg";